import {
  // COMMON
  Page404LayoutComponent,
} from '@net7/boilerplate-common';

// MURUCA
import {
  MrHomeLayoutComponent,
  MrSearchLayoutComponent,
  MrStaticLayoutComponent,
  MrResourceLayoutComponent,
  // MrTimelineLayoutComponent,
  // MrAdvancedSearchLayoutComponent,
  // MrAdvancedResultsLayoutComponent,
  // MrItineraryLayoutComponent,
  LocaleDependenciesGuard,
} from '@net7/boilerplate-muruca';

type RouteConfig = {
  component?: any;
  paths: {
    [locale: string]: string;
  };
  data?: any;
  isRedirect?: boolean;
  redirectTo?: {
    [locale: string]: string;
  };
};

const NOT_FOUND_PATH = 'page-404';
const config: {
  [layoutID: string]: RouteConfig;
} = {

  // GRAFFITI
  graffiti: {
    paths: { it: 'graffiti', en: 'en/graffiti' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-graffiti' },
  },
  graffito: {
    isRedirect: true,
    paths: { it: 'graffito/:id/:slug', en: 'en/graffito/:id/:slug' },
    redirectTo: { it: 'graffito/:id/:slug/localization', en: 'en/graffito/:id/:slug/localization' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito' },
  },
  localization: {
    paths: { it: 'graffito/:id/:slug/localization', en: 'en/graffito/:id/:slug/localization' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-localization' },
  },
  date: {
    paths: { it: 'graffito/:id/:slug/date', en: 'en/graffito/:id/:slug/date' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-date' },
  },
  description: {
    paths: { it: 'graffito/:id/:slug/description', en: 'en/graffito/:id/:slug/description' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-description' },
  },
  text: {
    paths: { it: 'graffito/:id/:slug/text', en: 'en/graffito/:id/:slug/text' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-text' },
  },
  conservation: {
    paths: { it: 'graffito/:id/:slug/conservation', en: 'en/graffito/:id/:slug/conservation' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-conservation' },
  },
  biblio: {
    paths: { it: 'graffito/:id/:slug/biblio', en: 'en/graffito/:id/:slug/biblio' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-biblio' },
  },
  observation: {
    paths: { it: 'graffito/:id/:slug/observation', en: 'en/graffito/:id/:slug/observation' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-observation' },
  },
  links: {
    paths: { it: 'graffito/:id/:slug/links', en: 'en/graffito/:id/:slug/links' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-graffito-links' },
  },

  // PERSONE
  persons: {
    paths: { it: 'people', en: 'en/people' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-persons' },
  },
  persona: {
    paths: { it: 'persona/:id/:slug', en: 'en/persona/:id/:slug' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-persona' },
  },

  // VOCE ONOMASTICA
  onomastic_repertoire: {
    paths: { it: 'onomastic-repertoire', en: 'en/onomastic-repertoire' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-voce_onomastica' },
  },
  voce_onomastica: {
    paths: { it: 'voce_onomastica/:id/:slug', en: 'en/voce_onomastica/:id/:slug' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-voce_onomastica' },
  },

  // CARICHE E TITOLI
  cariche: {
    paths: { it: 'offices', en: 'en/offices' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-cariche' },
  },
  carica: {
    paths: { it: 'carica/:id/:slug', en: 'en/carica/:id/:slug' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-carica' },
  },

  // INDICE LESSICALE
  lexicon: {
    paths: { it: 'lexicon', en: 'en/lexicon' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-termini' },
  },
  termine: {
    paths: { it: 'termine/:id/:slug', en: 'en/termine/:id/:slug' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-termine' },
  },

  // FORMULE DI DATAZIONE (le schede sono termini: il dettaglio usa la route termine)
  dating_formulas: {
    paths: { it: 'dating-formulas', en: 'en/dating-formulas' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-formule-datazione' },
  },

  // INDICE DEI TOPONIMI
  toponyms: {
    paths: { it: 'toponyms', en: 'en/toponyms' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-luoghi' },
  },
  luogo: {
    paths: { it: 'luogo/:id/:slug', en: 'en/luogo/:id/:slug' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-luogo' },
  },

  // INDICE DELLE ENTITA' POLITICO-AMMINISTRATIVE
  organizations: {
    paths: { it: 'organizations', en: 'en/organizations' },
    component: MrSearchLayoutComponent,
    data: { configId: 'search-organizzazioni' },
  },
  organizzazione: {
    paths: { it: 'organizzazione/:id/:slug', en: 'en/organizzazione/:id/:slug' },
    component: MrResourceLayoutComponent,
    data: { configId: 'resource-organizzazione' },
  },


  // text: {
  //   paths: { it: 'testo/:id/:slug', en: 'en/text/:id/:slug' },
  //   component: MrResourceLayoutComponent,
  //   data: { configId: 'resource-text' },
  // },

  // TESTIMONI
  // testimoni: {
  //   paths: { it: 'testimoni', en: 'en/witnesses' },
  //   component: MrSearchLayoutComponent,
  //   data: { configId: 'search-witnesses' },
  // },
  // witness: {
  //   paths: { it: 'testimone/:id/:slug', en: 'en/witness/:id/:slug' },
  //   component: MrResourceLayoutComponent,
  //   data: { configId: 'resource-witness' },
  // },

  // BIBLIOTECA
  // biblioteca: {
  //   paths: { it: 'biblioteca', en: 'en/library' },
  //   component: MrSearchLayoutComponent,
  //   data: { configId: 'search-books' },
  // },  
  // book: {
  //   paths: { it: 'libro/:id/:slug', en: 'en/book/:id/:slug' },
  //   component: MrResourceLayoutComponent,
  //   data: { configId: 'resource-book' },
  // },

  // BIBLIOGRAFIA
  // bibliografia: {
  //   paths: { it: 'bibliografia', en: 'en/bibliography' },
  //   component: MrSearchLayoutComponent,
  //   data: { configId: 'search-bibliografia' },
  // }, 
  
  // BIOGRAFIA (VITE-ANTICHE)
  // 'vite-antiche': {
  //   paths: { it: 'vite-antiche', en: 'en/old-lifes' },
  //   component: MrSearchLayoutComponent,
  //   data: { configId: 'search-biographies' },
  // },
  // biography: {
  //   paths: { it: 'biografia/:id/:slug', en: 'en/biography/:id/:slug' },
  //   component: MrResourceLayoutComponent,
  //   data: { configId: 'resource-biography' },
  // },

  // ICONOGRAFIA
  // iconografia: {
  //   paths: { it: 'iconografia', en: 'en/iconography' },
  //   component: MrSearchLayoutComponent,
  //   data: { configId: 'search-iconographies' },
  // },
  // iconography: {
  //   paths: { it: 'iconografia/:id/:slug', en: 'en/iconography/:id/:slug' },
  //   component: MrResourceLayoutComponent,
  //   data: { configId: 'resource-iconography' },
  // },

  // MATERIALI E STRUMENTI
  // search_tools: {
  //   paths: { it: 'materiali_strumenti', en: 'en/tools' },
  //   component: MrSearchLayoutComponent,
  //   data: { configId: 'search-tools' },
  // },
  // tools: {
  //   paths: { it: 'strumenti/:id/:slug', en: 'en/tools/:id/:slug' },
  //   component: MrResourceLayoutComponent,
  //   data: { configId: 'resource-tools' },
  // },

  // CRONOLOGIA
  // timeline: {
  //   paths: { it: 'timeline', en: 'en/timeline' },
  //   component: MrTimelineLayoutComponent,
  //   data: { configId: 'timeline' },
  // },
  // timelineItem: {
  //   component: MrTimelineLayoutComponent,
  //   paths: { it: 'timeline/:id/:slug', en: 'en/timeline/:id/:slug' },
  //   data: { configId: 'timeline' }
  // },
  // view_time_event: {
  //   paths: { it: 'time_event/:id/:slug', en: 'en/view_time_event/:id/:slug' },
  //   component: MrTimelineLayoutComponent,
  //   data: { configId: 'timeline' },
  // },

  // PERCORSI
  // itinerary: {
  //   paths: { it: 'percorsi/:id/:slug', en: 'en/itinerary/:id/:slug' },
  //   component: MrItineraryLayoutComponent,
  //   data: { configId: 'itinerary' },
  // },

  // RICERCA AVANZATA
  // search: {
  //   paths: { it: 'ricerca-avanzata', en: 'en/research' },
  //   component: MrAdvancedSearchLayoutComponent,
  //   data: { configId: 'advanced-search' },
  // },
  // search_results: {
  //   paths: { it: 'risultati', en: 'en/results' },
  //   component: MrAdvancedResultsLayoutComponent,
  //   data: { configId: 'advanced-results' },
  // },
  
  // POST
  // post: {
  //   component: MrStaticLayoutComponent,
  //   paths: {
  //     it: 'post/:slug',
  //     en: 'en/post/:slug',
  //   },
  //   data: { configId: 'post' },
  // },

  // HOME
  home: {
    component: MrHomeLayoutComponent,
    paths: { it: '', en: 'en/' },
    data: { configId: 'home' },
  },
  homeRedirect: { 
    paths: { en: 'en' }, 
    isRedirect: true 
  },

  // PAGE 404
  page404: {
    paths: { it: NOT_FOUND_PATH, en: `en/${NOT_FOUND_PATH}` },
    component: Page404LayoutComponent,
    data: { id: 'page-404' },
  },

  // PAGINA STATICA
  page: {
    component: MrStaticLayoutComponent,
    paths: {
      it: ':slug',
      en: 'en/:slug',
    },
    data: { configId: 'page' },
  },
};

const APP_ROUTES: any = [
  {
    path: 'home',
    redirectTo: '',
    pathMatch: 'full',
  },
];

/**
 * Generate angular routes from config
 */
Object.keys(config).forEach((routeId) => {
  const { component, data, paths, isRedirect, redirectTo } = config[routeId];
  Object.entries(paths).forEach(([locale, path]) => {
    if (!isRedirect) {
      // path to component
      if (component) {
        APP_ROUTES.push({
          path,
          component,
          data: { ...data, routeId, locale },
          canActivate: [LocaleDependenciesGuard],
        });
      }
    } else {
      APP_ROUTES.push({ 
        path, 
        redirectTo: redirectTo ? redirectTo[locale] : `${path}/`,
        data: { ...data, routeId, locale }, 
      });
    }
  });
});

export { APP_ROUTES };